import { render, staticRenderFns } from "./LoanDetailDialog.vue?vue&type=template&id=285452ea&scoped=true"
import script from "./LoanDetailDialog.vue?vue&type=script&lang=js"
export * from "./LoanDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./LoanDetailDialog.vue?vue&type=style&index=0&id=285452ea&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "285452ea",
  null
  
)

export default component.exports